import React, { useContext } from 'react';
import { useDeletePracticalEvidenceMutation } from '../../../services/SkillsManagement';
import { useDispatch } from 'react-redux';
import { DELETE_PRACTICAL_EVIDENCE, ADD_PRACTICAL_EVIDENCE } from '../../../Reducers/Actions';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import DeleteIcon from '@mui/icons-material/Delete';
import { MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import { SnackBarContext } from '../../../Context/SnackBarContextProvider';
import MuiDialog from '../../../SystemDesign/MuiDialog';

/**
 * DeletePractileEvidence Component - Allows deleting a practical evidence
 * Mirrors the pattern from `src/components/Postes/DeletePoste.jsx`
 * @param {Object} props
 * @param {Object} props.row - The row object containing the evidence data
 */
const DeletePractileEvidence = ({ row, label }) => {
  const [deleteEvidence, { isLoading }] = useDeletePracticalEvidenceMutation();
  const dispatch = useDispatch();

  const { setInfoAlert, setOpenSnackBar } = useContext(SnackBarContext);

  const evidence = row?.original || {};
  const evidenceId = evidence?.id ?? evidence?.evidenceId ?? evidence?.evidence_id;

  if (!evidenceId) return null;

  const handleDelete = async () => {
    try {
      // Optimistic delete immediately
      dispatch({ type: DELETE_PRACTICAL_EVIDENCE, evidenceId });
      const response = await deleteEvidence({ evidenceId }).unwrap();

      let successMessage;
      if (typeof response === 'string') {
        successMessage = response;
      } else if (response && typeof response === 'object' && response.message) {
        successMessage = response.message;
      } else {
        const name = evidence.file_name || evidence.name || evidence.url || evidence.evidence_url || evidenceId;
        successMessage = `Evidence "${name}" deleted successfully`;
      }

      setInfoAlert({ severity: 'success', message: successMessage });
      setOpenSnackBar(true);
      return true;
    } catch (error) {
      // roll back optimistic deletion
      try {
        dispatch({ type: ADD_PRACTICAL_EVIDENCE, payload: evidence });
      } catch (_) {}
      let errorMessage = 'An error occurred while deleting';
      if (error?.data?.message) {
        errorMessage = typeof error.data.message === 'string' ? error.data.message : JSON.stringify(error.data.message);
      } else if (error?.message) {
        errorMessage = error.message;
      }
      setInfoAlert({ severity: 'error', message: errorMessage });
      setOpenSnackBar(true);
      return false;
    }
  };

  const triggerButton = (
    <MenuItem>
      <ListItemIcon>
        <DeleteIcon fontSize="small" color="error" />
      </ListItemIcon>
      <ListItemText>{label || 'Delete'}</ListItemText>
    </MenuItem>
  );

  const displayName = evidence.file_name || evidence.name || evidence.url || evidence.evidence_url || evidenceId;
  const dialogContent = (
    <div>
      <p>Are you sure you want to delete {displayName}?</p>
      <p>This action is irreversible</p>
    </div>
  );

  return (
    <MuiDialog
      icon={<DeleteOutlineIcon />}
      triggerButton={triggerButton}
      title="Delete Evidence"
    //   subtitle={`Are you sure you want to delete ${displayName}`}
      content={dialogContent}
      maxWidth="xs"
      existAction={true}
      actionTitle="Delete"
      actionFunction={handleDelete}
      isLoading={isLoading}
    />
  );
};

// Static properties for menu integration
DeletePractileEvidence.menuIcon = <DeleteOutlineIcon fontSize="small" />;
DeletePractileEvidence.menuLabel = 'Delete Evidence';

export default DeletePractileEvidence;
